// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { i18n } from '../../../index'
import { withRouter } from 'react-router-dom'
import StationPage from '../StationPage'
import WastageBoundary from './WastageBoundary'
import css from '../stationPage.css'
import { Paper } from '@mui/material'
import { Query } from 'react-apollo'
import { fetchAllWastageBoundariesForAllProductTypes } from '../../../station/stationWastageQueries'
import Loader from '../../../../common/loader/Loader'

class WastageBoundaryPage extends React.Component<{
  match: {
    params: {
      stationId: string
    }
  }
}> {
  render(): React.ReactElement<typeof React.Component> {
    return (
      <StationPage title={i18n.t('admin.stations.title.wastageBoundaryPage')}>
        {({ station }) => (
          <div className={css.component}>
            <Paper>
              <div
                style={{
                  padding: '12px',
                }}
              >
                <Query
                  fetchPolicy='cache-and-network'
                  query={fetchAllWastageBoundariesForAllProductTypes}
                  variables={{
                    stationId: station.id,
                  }}
                >
                  {({ data, loading, error, refetch }) => (
                    <Loader
                      {...{
                        loading,
                        error,
                      }}
                    >
                      <WastageBoundary
                        stationId={station.id}
                        data={data.getAllWastageBoundariesForAllProductTypes}
                        refetch={refetch}
                      />
                    </Loader>
                  )}
                </Query>
              </div>
            </Paper>
          </div>
        )}
      </StationPage>
    )
  }
}

export default withRouter(WastageBoundaryPage)
